export const AUTH_KEYS = {
  AUTHORIZATION: 'Authorization',
  AUTHORIZATION_RA: 'AuthorizationRA',
  AUTHORIZATION_FORCE: 'Authorization_force',
  CLIENT_ID_FORCE: 'clientIdForce',
  SESSION: 'SESSION_KEY',
  SESSION_TOKEN: 'SESSION_TOKEN_KEY',
  LOGOUT_TIMEOUT: 'LOGOUT_TIMEOUT_KEY',
  SLUG: 'slug',
  AMBIENT: 'ambient_to',
  IN_FORCE: 'inForce',
} as const;
